import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getPortlandStructuredData() {
  const url = "https://restorehair.com/locations/oregon/portland/";
  const description =
    "Find out about your hair transplant options in Portland with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("portland", url, description),
    locationPageCrumbs(url, "Portland"),
  ];
}
